import api from '@/assets/plugins/axios'
import axios from 'axios'
import {backendUrl} from '@/assets/js/config'
import queryString from 'querystring'

let headers = {'Content-type': 'application/x-www-form-urlencoded'}

class SpaceService {
  // 获取用户列表
  queryUserList (params) {
    return api.get(`${backendUrl}/user/employee_list`, params)
  }

  // 员工创建分享
  sendShareMessages (params) {
    return api.post(`${backendUrl}/share/file`, params)
  }

  // 个人创建分享
  sendSharePersonMessages (params) {
    return api.post(`${backendUrl}/share/file/link`, params)
  }

  // 下載
  canDownLoadFile (url) {
    let _self = {}
    let CancelToken = axios.CancelToken
    return axios.get(url, {
      cancelToken: new CancelToken(function executor (c) {
        _self.cancel = c
        setTimeout(() => {
          _self.cancel()
        })
      })
    }).then(ret => {
      return ret
    })
  }

  getFileListSimple (params) {
    return api.post(`${backendUrl}/file/list_simple`, params).then(ret => {
      return ret
    })
  }

  getFileList (params) {
    if (/\/database\/data\/record\//.test(window.location.href)) {
      return api.post(`${backendUrl}/projects/recorded/file`, params)
    }
    return api.post(`${backendUrl}/file/list`, params).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  getSearchFileList (params) {
    return api.post(`${backendUrl}/file/search`, params).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  deleteFile (params) {
    return api.deleteBody(`${backendUrl}/file/delete?workspaceId=${params.workspaceId}`, params.pathList).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  downloadFiles (params) {
    let paramsData = {
      filePathList: params.filePathListm,
      folderPathList: params.folderPathList
    }
    if (/\/database\/data\/record\//.test(window.location.href)) {
      let data = {
        filePaths: params.filePathListm.join(','),
        folderPaths: params.folderPathList.join(','),
        projectId: params.projectId
      }
      return api.get(`${backendUrl}/projects/recorded/file/pre_batch_download`, data)
    }
    return api.post(`${backendUrl}/file/pre_batch_download?workspaceId=${params.workspaceId}`, paramsData).then(ret => {
      return ret
    })
  }

  downloadFile (path, token, workspaceId) {
    // let _self = {}
    let CancelToken = axios.CancelToken
    return axios.get(`${backendUrl}/file/download?path=${path}&token=${token}&workspaceId=${workspaceId}`, {
      cancelToken: new CancelToken(function executor (c) {
        // _self.cancel = c
        // setTimeout(() => { _self.cancel() }, 200)
      })
    }).then(ret => {
      // setTimeout(() => { _self.cancel() }, 200)
      return {code: 200}
    })
  }
  // 优化的接口
  downloadFile_new (path, token, workspaceId){
    // let _self = {}
    let CancelToken = axios.CancelToken
    return axios.get(`${backendUrl}/file/signed_url?filePath=${path}&token=${token}&workspaceId=${workspaceId}`, {
      // eslint-disable-next-line no-unused-vars
      cancelToken: new CancelToken(function executor (c) {
        // _self.cancel = c
        // setTimeout(() => { _self.cancel() }, 200)
      })
      // eslint-disable-next-line no-unused-vars
    }).then(ret => {
      // setTimeout(() => { _self.cancel() }, 200)
      return ret
    })
  }
  getDownloadFilesState (params) {
    if (/\/database\/data\/record\//.test(window.location.href)) {
      return api.get(`${backendUrl}/projects/recorded/file/download_state`, params)
    }
    return api.get(`${backendUrl}/file/download_state`, params).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  putFileRename (params) {
    return api.put(`${backendUrl}/file/rename`, params, headers).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  createFolder (params) {
    return api.post(`${backendUrl}/file/create_folder`, params, headers).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  fileCopy (params) {
    return api.post(`${backendUrl}/file/copy`, params).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  fileMove (params) {
    return api.post(`${backendUrl}/file/move`, params).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  fileExist (params) {
    return api.post(`${backendUrl}/file/exist`, params).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  // 1. 获取 空间文件 预览按钮组
  getOperateButtons (params) {
    return api.get(`${backendUrl}/ysj/buttons`, params)
  }

  // 1.1 预览文件
  previewFile (params, isRecord) {
    if (/\/database\/data\/record\//.test(window.location.href) || isRecord) {
      return api.get(`${backendUrl}/projects/recorded/file/signed_url`, params)
    }
    return api.get(`${backendUrl}/file/signed_url`, params)
  }

  // 1.2 GDQ、GQI4 查询模型解析状态
  getModelState (params) {
    return api.get(`${backendUrl}/bim/model_state`, params)
  }

  // 1.3 获取预览文件的 viewId 和 viewToken
  getViewToken (params) {
    return api.get(`${backendUrl}/bim/view/token`, params)
  }

  // 2. 获取项目列表
  getProjectList (params) {
    return api.get(`${backendUrl}/projects`, params)
  }

  // x.1 获取已登录用户的空间列表
  getWorkspaceList () {
    return api.get(`${backendUrl}/workspace/list`)
  }

  // x.2 根据空间id 查询空间使用情况
  getWorkspaceById (params) {
    return api.get(`${backendUrl}/workspace/capacity`, params)
  }

  // 是否使用过企业空间
  getHasUsedWorkspace () {
    return api.get(`${backendUrl}/workspace/has_used_employee_workspace`)
  }

  // 删除项目
  deleteProject (params) {
    return api.delete(`${backendUrl}/projects/${params.projectId}`, {})
  }

  // 重命名
  renameProject (params) {
    return api.put(`${backendUrl}/file/rename?` + queryString.stringify(params), {})
  }


  // 获取项目所有可选类型
  getProjectType () {
    return api.get(`${backendUrl}/projects/types`, {}).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  // 创建项目
  addProject (params, headers) {
    return api.post(`${backendUrl}/projects`, params, headers).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  // 获取未添加到项目空间的成员
  getUserList (params) {
    return api.get(`${backendUrl}/projects/user_list`, params).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  // 获取项目信息
  getProjectInfo (params, headers) {
    return api.get(`${backendUrl}/projects/${params.projectId}`, {}, headers).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  // 修改项目信息
  putProjectInfo (params, headers) {
    return api.put(`${backendUrl}/projects/${params.projectId}`, params, headers).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  // 获取项目成员
  companyProjectMember (params, headers) {
    return api.get(`${backendUrl}/projects/${params.projectId}/members`, {}, headers).then(ret => {
      // console.log(ret);
      return ret
    })
  }


  // 删除项目成员
  deleteProjectMember (params) {
    let query = {
      url: params.url
    }
    return api.delete(`${backendUrl}/projects/${params.projectId}/members/${params.memberId}?` + queryString.stringify(query), {}).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  // 添加项目成员
  confirmAddProjectMember (params, query) {
    return api.post(`${backendUrl}/projects/${query.projectId}/member?` + queryString.stringify(params), {}).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  /** 记录项目操作(创建、重命名、删除)
   * @params String token
   * @params String workspaceId
   * @params String companyId
   * @params Array records
   */
  addCompanyOpration (params, headers) {
    if (params.records) {
      params.records = JSON.stringify(params.records)
    }
    return api.post(`${backendUrl}/ProjectLog/add`, qs.stringify(params), formHeaders).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  /** 记录项目文件、概要操作
   * @params String token
   * @params String workspaceId
   * @params String companyId
   * @params Array records
   */
  addCompanyProjectOpration (params, headers) {
    if (params.records) {
      params.records = JSON.stringify(params.records)
    }
    return api.post(`${backendUrl}/project_ws_log`, qs.stringify(params), formHeaders).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  // 获取企业员工空间列表
  getEmployeeWorkspaceInfos (params) {
    return api.get(`${backendUrl}/workspace/employee_workspace_infos`, params).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  // 删除已离职员工空间
  delEmployeeWorkspaceInfo (params) {
    return api.delete(`${backendUrl}/workspace/employee_workspace_info`, params, headers).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  // 复制文件(同名文件夹合并)
  copyFile (params) {
    return api.post(`${backendUrl}/file/copy`, params).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  // 10.0 获取我收到的分享工程 文件列表
  getShareFileList (params) {
    return api.post(`${backendUrl}/share/files`, params).then(ret => {
      return ret
    })
  }

  // 10.1 下载 收到的分享文件
  //   downloadShareFile (params) {
  //     window.common.downloadFile();
  //   }
  // 10.2 删除 收到的分享文件
  deleteShareFile (params) {
    return api.deleteArr(`${backendUrl}/share/file`, params.shareIds, {'Content-type': 'application/json'}).then(ret => {
      return ret
    })
  }

  // 10.3 转存 收到的分享文件
  saveShareFile (params) {
    return api.post(`${backendUrl}/share/files/transfer`, params, headers).then(ret => {
      return ret
    })
  }

  // 工程项目-全部列表
  getAllPrjList (params) {
    if (/\/database\/data\/record\//.test(window.location.href)) {
      return api.get(`${backendUrl}/projects/recorded/file/all`, params, headers)
    }
    return api.get(`${backendUrl}/projects/${params.id}/file`, params, headers)
  }

  // 工程项目-全部查询
  getAllPrjSearch (params) {
    if (/\/database\/data\/record\//.test(window.location.href)) {
      return api.get(`${backendUrl}/projects/recorded/file/search`, params, headers)
    }
    return api.get(`${backendUrl}/projects/${params.id}/file/search`, params, headers)
  }

  // 获取文件信息
  getFileMeta (query) {
    return api.get(`${backendUrl}/file/meta`, query).then(ret => {
      // console.log(ret);
      return ret
    })
  }
}

export default new SpaceService()
